import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";

const PopoverContainer = styled.div`
  &.event-tip {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    text-align: center;
    min-width: 60px;
    min-height: 28px;
    border: 1px solid ${Color.veryWhiteGrey()};
    border-radius: 4px;
    pointer-events: none;
    opacity: 0;
    background-color: ${Color.white()};
    filter: drop-shadow(0 0 1.5rem ${Color.denseFog()});

    & .tip-title {
      flex: 1;
      align-content: flex-start;
      justify-content: center;
      padding: 8px;
      font-weight: 400;
      font-size: 0.8em;
      color: ${Color.gray()};
      border-bottom: 1px solid ${Color.veryWhiteGrey()};
    }

    & .tip-content {
      flex: 1;
      padding: 0.2em 12px;
      font-weight: 400;
      font-size: 0.9em;
      color: ${Color.gray()};

      & .violation-type {
        color: ${Color.guardsmanRed()};
      }
    }
  }

  &.event-tip:before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid ${Color.white()};
    left: -8px;
    top: 7px;
  }
`;

export const Component = () => (
  <PopoverContainer className="event-tip">
    <div className="tip-title" />
    <div className="tip-content" />
  </PopoverContainer>
);
